// トップページカテゴリアイコンスライド用のSwiperインスタンス

const swiperCat = new Swiper( '.swiper-cat', {
	// ページネーション
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
		type: "bullets"
	},
	// 前後の矢印
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	// スライドのループ
	loop: true,
	// 画面表示数
	slidesPerView: 3,
	centeredSlides: false,
	//レスポンシブによる表示数切り替え
	breakpoints: {
		560: {
			slidesPerView: 5,
		},
		750: {
			slidesPerView: 7,
		},
		1400: {
			slidesPerView: 8,
		}
	}
} );


